import {
  Bird,
  Cat,
  Dog,
  Fish,
  Rabbit,
  Flower2,
  Leaf,
  Sun,
  Moon,
  Star,
} from 'lucide-react';

export const AVATARS = [
  { id: 'bird', Icon: Bird, bg: 'bg-sky-100', color: 'text-sky-700' },
  { id: 'cat', Icon: Cat, bg: 'bg-orange-100', color: 'text-orange-700' },
  { id: 'dog', Icon: Dog, bg: 'bg-amber-100', color: 'text-amber-700' },
  { id: 'fish', Icon: Fish, bg: 'bg-teal-100', color: 'text-teal-700' },
  { id: 'rabbit', Icon: Rabbit, bg: 'bg-pink-100', color: 'text-pink-700' },
  { id: 'flower', Icon: Flower2, bg: 'bg-purple-100', color: 'text-purple-700' },
  { id: 'leaf', Icon: Leaf, bg: 'bg-green-100', color: 'text-green-700' },
  { id: 'sun', Icon: Sun, bg: 'bg-yellow-100', color: 'text-yellow-700' },
  { id: 'moon', Icon: Moon, bg: 'bg-indigo-100', color: 'text-indigo-700' },
  { id: 'star', Icon: Star, bg: 'bg-rose-100', color: 'text-rose-700' },
];

export const DEFAULT_AVATAR_ID = 'bird';

export function getAvatar(id) {
  return AVATARS.find((a) => a.id === id) || AVATARS[0];
}
